import React, { Component } from "react";
import DupontIconButton from "../DupontIconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShare } from "@fortawesome/free-solid-svg-icons";

class ShareRenderer extends Component {
  constructor(props) {
    super(props);
    this.invokeParentMethod = this.invokeParentMethod.bind(this);
  }

  invokeParentMethod() {
    this.props.context.shareHandler(this.props.node.data);
  }

  render() {
    const { context, node } = this.props;
    const userEmail = context.userEmail;
    const createdBy = node.data.created_by;
    const isDisabled = userEmail !== createdBy;
    return (
      <div style={{ margin: 2 }}>
        <DupontIconButton
          onClick={this.invokeParentMethod}
          customClass={{ margin: "2px" }}
          disabled={isDisabled}
        >
          <FontAwesomeIcon icon={faShare} color="white" />
        </DupontIconButton>
      </div>
    );
  }
}

export default ShareRenderer;
